
export default {
  name: 'LandingAdditionalHighlight',
  data() {
    return {
      loadContent: false,
      itemsAds: [],
    }
  },

  mounted() {
    this.fn_loadThumnailContent()
  },

  methods: {
    async fn_loadThumnailContent() {
      try {
        this.loadContent = true
        const payload = {
          page: 1,
          perPage: 10,
        }

        const callApi = await this.$axios.post(
          process.env.apiWebContent + 'v2/getContents',
          payload
        )
        if (callApi.data.status === 'OK') {
          this.itemsAds = callApi.data.result.data
        }
        this.loadContent = false
      } catch (err) {
        this.loadContent = false
        console.log(err)
      }
    },

    fn_goToContent(_path) {
      // console.log(_path)
      this.$router.push({ path: '/blog/' + _path })
    },
  },
}
